module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/modules/_iterators.js
// module id = 78
// module chunks = 168707334958949